import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import { createAsyncReducer } from 'redux-easy-async';
import * as Actions from "../actions";
export default createAsyncReducer( // make Actions into a real array instead of "array like"
Object.keys(Actions).map(function (key) {
  return Actions[key];
}));